import { JsonObject, JsonProperty } from 'json2typescript';
import { ApiResultsResponse } from '../../api/responses/api-results-response.model';
import { UserCollection } from '../user-collection.model';

@JsonObject('UserCollectionsResultsResponse')
export class UserCollectionsResultsResponse extends ApiResultsResponse<UserCollection> {

  @JsonProperty('results', [UserCollection])
  override results: UserCollection[] = [];

  @JsonProperty('results_total', Number)
  resultsTotal: number = 0;
}
